var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgHomeIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 9.26215C4.5 8.98238 4.5 8.8425 4.53531 8.71316C4.5666 8.59858 4.61805 8.49049 4.68725 8.39395C4.76536 8.28499 4.87392 8.19678 5.09105 8.02036L11.4911 2.82036C11.8507 2.52814 12.0305 2.38204 12.2304 2.32608C12.4068 2.27672 12.5932 2.27672 12.7696 2.32608C12.9695 2.38204 13.1493 2.52814 13.5089 2.82036L19.9089 8.02036C20.1261 8.19678 20.2346 8.28499 20.3128 8.39395C20.382 8.49049 20.4334 8.59858 20.4647 8.71316C20.5 8.8425 20.5 8.98238 20.5 9.26214V18.4006C20.5 18.9606 20.5 19.2407 20.391 19.4546C20.2951 19.6427 20.1422 19.7957 19.954 19.8916C19.7401 20.0006 19.4601 20.0006 18.9 20.0006H6.1C5.53995 20.0006 5.25992 20.0006 5.04601 19.8916C4.85785 19.7957 4.70487 19.6427 4.60899 19.4546C4.5 19.2407 4.5 18.9606 4.5 18.4006V9.26215Z",
    stroke: "#697586",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeIcon);
export default __webpack_public_path__ + "static/media/home-icon.19345f09.svg";
export { ForwardRef as ReactComponent };